/* eslint-disable */
import React, { Component } from 'react';
import cn from 'classnames';
import styles from './About.scss';
import { withTranslation } from 'react-i18next';
import { isSectionAllowed } from '../helper';
import { gaEvent, trackGA } from 'services/ga'

const checkIsNotEmty = (data) => {
  if (!data) {
    return false;
  }

  return data.name !== undefined && data.name !== null;
}

class About extends Component {

  componentDidMount() {
    this.handleTrackEvent({eventLabel: 'obshchie_harakteristiki'})
    this.handleTrackEvent({eventLabel: 'kommunikacii'})
  }

  handleTrackEvent = ({eventLabel}) => {
    const { building, objectType, profile } = this.props;
    const { title, id } = building.data;

    trackGA(gaEvent.buildingInfoBlocksShow({
      eventLabel,
      productType: objectType,
      productName: title,
      productID: id,
      user_id: profile.id
    }));
  };

  render() {
    const { className, building, client, print, t, currency } = this.props;
    const { data } = building;
    
    function renderParking() {
      const { house_parking, parking_underground, parking_multilevel, parking_type_roofed } = data.parking;
      let arr = [];

      house_parking ? arr.push(t('components.building.main.about.houseParking')) : null
      parking_underground ? arr.push(t('components.building.main.about.parkingUnderground')) : null
      parking_multilevel ? arr.push(t('components.building.main.about.parkingMultilevel')) : null
      parking_type_roofed ? arr.push(t('components.building.main.about.parkingTypeRoofed')) : null

      if (arr.length === 0) {
        return null;
      }

      let text = arr.join(', ');
      text = text[0].toUpperCase() + text.slice(1);

      return text;
    }

    return (
      <div className={cn(styles.About, className, {[styles.Client]: this.props.client}, {[styles.Print]: print})}>
        <div className={client ? styles.InnerClient : styles.Inner}>
          {isSectionAllowed('characteristics') && <div className={client ? styles.InfoBlockClient : styles.InfoBlock}>
            <div className={styles.AboutTitle}>
              {client ? (
                  <span>{t('components.building.main.about.commonInfo')}</span>
              ) : (
                <span>
                  <span className={styles.NotMobile}>{t('components.building.main.about.commonInfo')}</span>
                  <span className={styles.OnlyMobile}>{t('components.building.main.about.info')}</span>
                </span>
              )}
            </div>
            <div className={styles.InfoBlockInner}>
              {checkIsNotEmty(data.class) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.class')}
                  </span>
                  <span className={styles.Description}>{data.class.name}</span>
                </div>
              )}
              {checkIsNotEmty(data.material) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.material')}
                  </span>
                  <span className={styles.Description}>{data.material.name}</span>
                </div>
              )}
              {data.type_id != 2 && checkIsNotEmty(data.types) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.type')}
                  </span>
                  <span className={styles.Description}>{data.types.name}</span>
                </div>
              )}
              {checkIsNotEmty(data.houseRoad) && (
                  <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                    <span className={styles.Title}>
                      {t('components.building.main.about.houseRoad')}
                    </span>
                    <span className={styles.Description}>
                      {data.houseRoad.name}
                    </span>
                  </div>
              )}
              {renderParking() && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.parking')}
                  </span>
                  <span className={styles.Description}>
                    <span className={styles.Park}>{renderParking()}</span>
                  </span>
                </div>
              )}
              {data.house_territory && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.territory')}
                  </span>
                  <span className={styles.Description}>{data.house_territory}</span>
                </div>
              )}
              {!!data.distance_sea && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.distanceSea')}
                  </span>
                  <span className={styles.Description}>{data.distance_sea}  {t('components.building.main.about.meters')}</span>
                </div>
              )}
              {!!data.ceiling_height && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.cealingHeight')}
                  </span>
                  <span className={styles.Description}>
                    {data.ceiling_height} {t('components.building.main.about.meters')}
                  </span>
                </div>
              )}
              {!!data.service_cost && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.serviceCost')}
                  </span>
                  <span className={styles.Description}>
                    {data.service_cost} {t('components.building.main.about.cost', {currency})}
                  </span>
                </div>
              )}
            </div>
          </div>}

          {this.props.children}

          {isSectionAllowed('communications') &&
          <div className={client ? styles.InfoBlockClient : styles.InfoBlock}>
            <div className={styles.AboutTitle}>
              {t('components.building.main.about.communication')}
            </div>
            <div className={styles.InfoBlockInner}>
              {checkIsNotEmty(data.gas) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.gas')}
                  </span>
                    <span className={styles.Description}>
                    {(data.gas && data.gas.name) || '-'}
                  </span>
                </div>
              )}
              {checkIsNotEmty(data.heating) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                <span className={styles.Title}>
                  {t('components.building.main.about.heating')}
                </span>
                  <span className={styles.Description}>
                  {(data.heating && data.heating.name) || '-'}
                </span>
                </div>
              )}

              {checkIsNotEmty(data.electricity) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.electricity')}
                  </span>
                  <span className={styles.Description}>
                    {(data.electricity && data.electricity.name) || '-'}
                  </span>
                </div>
              )}
              {checkIsNotEmty(data.sewage) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.sewage')}
                  </span>
                  <span className={styles.Description}>
                    {(data.sewage && data.sewage.name) || '-'}
                  </span>
                </div>
              )}
              {checkIsNotEmty(data.water) && (
                <div className={client ? styles.InfoItemClient : styles.InfoItem}>
                  <span className={styles.Title}>
                    {t('components.building.main.about.water')}
                  </span>
                  <span className={styles.Description}>
                    {(data.water && data.water.name) || '-'}
                  </span>
                </div>
              )}
            </div>
          </div>}
        </div>
      </div>
    );
  }
};

export default withTranslation()(About);



// WEBPACK FOOTER //
// ./src/components/Building/Main/About/About.js